import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useRef, useState, createElement, cloneElement, Children } from 'react';
import * as ReactIs from 'react-is';
import PropTypes from 'prop-types';
import { isEqual as _isEqual, isEmpty as _isEmpty } from 'lodash';
import { map as mapUtils } from '@gisatcz/ptr-utils';
import { Error } from '@gisatcz/ptr-atoms';
import { mapConstants } from '@gisatcz/ptr-core';
import MapWrapper from './MapWrapper';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PresentationMap = function PresentationMap(_ref) {
  var onClick = _ref.onClick,
    active = _ref.active,
    activeSelectionKey = _ref.activeSelectionKey,
    backgroundLayer = _ref.backgroundLayer,
    children = _ref.children,
    layers = _ref.layers,
    mapComponent = _ref.mapComponent,
    onMount = _ref.onMount,
    onUnmount = _ref.onUnmount,
    onPropViewChange = _ref.onPropViewChange,
    onResize = _ref.onResize,
    onViewChange = _ref.onViewChange,
    onZoomEnd = _ref.onZoomEnd,
    onPanEnd = _ref.onPanEnd,
    onMapRemove = _ref.onMapRemove,
    resetHeading = _ref.resetHeading,
    resources = _ref.resources,
    stateMapKey = _ref.stateMapKey,
    view = _ref.view,
    viewport = _ref.viewport,
    viewLimits = _ref.viewLimits,
    wrapper = _ref.wrapper,
    wrapperProps = _ref.wrapperProps,
    Tooltip = _ref.Tooltip,
    tooltipProps = _ref.tooltipProps,
    onLayerClick = _ref.onLayerClick,
    mapKey = _ref.mapKey,
    name = _ref.name,
    crs = _ref.crs,
    mapComponentProps = _ref.mapComponentProps;
  var _useState = useState({
      width: null,
      height: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];

  // const [stateView, setStateView] = useState({test: 'aaa'});
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    stateView = _useState4[0],
    setStateView = _useState4[1];
  useEffect(function () {
    if (!stateMapKey) {
      setStateView(_objectSpread(_objectSpread({}, mapConstants.defaultMapView), view));
    }
    if (typeof onUnmount === 'function') {
      return onUnmount;
    }
  }, []);
  var saveViewChange = function saveViewChange(view, checkViewEquality) {
    // if (checkViewEquality && !_isEqual(view, viewRef.current)) {
    viewRef.current = view;
    if (checkViewEquality && !_isEqual(view, stateView)) {
      if (!stateMapKey) {
        setStateView(view);
      }
    }
  };
  var getValidView = function getValidView(update) {
    var validView = _objectSpread(_objectSpread({}, mapConstants.defaultMapView), view);
    if (stateView && !_isEmpty(stateView)) {
      validView = _objectSpread(_objectSpread({}, stateView), update);
    }
    validView = mapUtils.view.ensureViewIntegrity(validView);
    return validView;
  };
  var onViewChangeDecorator = function onViewChangeDecorator(onViewChange) {
    return function (update) {
      onViewChange(update, size.width, size.height);
    };
  };
  var onViewChangeHandler = stateMapKey ? onViewChange : function (update) {
    var view = getValidView(update);

    // TODO buble view to map!!!
    saveViewChange(view, true);
    if (!_isEqual(view, stateView)) {
      if (onViewChange && !stateMapKey) {
        onViewChangeDecorator(onViewChange)(view);
      }
    }
  };
  var onPropViewChangeHandler = function onPropViewChangeHandler(view) {
    if (stateMapKey && onPropViewChange) {
      onViewChangeDecorator(onPropViewChange)(view);
    }
  };
  var viewRef = useRef(view);
  useEffect(function () {
    if (view) {
      var validView = getValidView(view);
      if (viewRef.current) {
        if (!_isEqual(validView, viewRef.current)) {
          if (!stateMapKey) {
            saveViewChange(validView, true);
          } else {
            onPropViewChangeHandler(validView);
          }
        }
      } else {
        if (!stateMapKey) {
          saveViewChange(validView, true);
        } else {
          onPropViewChangeHandler(validView);
        }
      }
    }
  }, [view]);
  var resetHeadingHandler = function resetHeadingHandler() {
    mapUtils.resetHeading(stateView.heading, function (heading) {
      return setStateView(_objectSpread(_objectSpread({}, stateView), {}, {
        heading: heading
      }));
    });
  };
  var onResizeHandler = function onResizeHandler(width, height) {
    if (onResize) {
      onResize(width, height);
    }
    setSize({
      width: width,
      height: height
    });
  };
  var renderContent = function renderContent(MapComponent, props, children) {
    //TODO is it correct to create element on each change?
    // const map = createElement(mapComponent, props);
    if (!children) {
      // return map
      return /*#__PURE__*/_jsx(MapComponent, _objectSpread({}, props));
    } else {
      return /*#__PURE__*/_jsxs("div", {
        className: "ptr-map-controls-wrapper",
        children: [/*#__PURE__*/_jsx(MapComponent, _objectSpread({}, props)), ";", Children.map(children, function (child) {
          return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
            view: props.view,
            mapKey: mapKey,
            viewLimits: viewLimits,
            updateView: props.onViewChange,
            active: active,
            onMapRemove: onMapRemove,
            resetHeading: stateMapKey ? resetHeading : resetHeadingHandler,
            mapWidth: stateMapKey ? viewport === null || viewport === void 0 ? void 0 : viewport.width : size.width,
            mapHeight: stateMapKey ? viewport === null || viewport === void 0 ? void 0 : viewport.height : size.height,
            name: name,
            crs: crs
          }));
        })]
      });
    }
  };
  if (!mapComponent) {
    return /*#__PURE__*/_jsx(Error, {
      centered: true,
      children: "mapComponent not supplied to Map"
    });
  } else {
    var usedView = view;
    if (!stateMapKey) {
      // onViewChangeHandledLocal = onViewChange;
      // what? whay? is it legal?
      // props.onResize = this.onResize;
      // if (!props.stateMapKey) {
      // 	props.view = this.state.view || props.view;
      // 	props.onViewChange = this.onViewChange;
      // }
      usedView = stateView;
    }
    if (wrapper) {
      // check if passed wrapper is React component or connected component
      var wrapperComponent = ReactIs.isValidElementType(wrapper) ? wrapper : MapWrapper;
      return /*#__PURE__*/createElement(wrapperComponent, _objectSpread({
        // FIXME better props definition
        activeSelectionKey: activeSelectionKey,
        backgroundLayer: backgroundLayer,
        layers: layers,
        mapComponent: mapComponent,
        onMount: onMount,
        onUnmount: onUnmount,
        onPropViewChange: onPropViewChangeHandler,
        resetHeading: stateMapKey ? resetHeading : resetHeadingHandler,
        stateMapKey: stateMapKey,
        mapKey: mapKey,
        viewport: viewport,
        viewLimits: viewLimits,
        wrapper: wrapper,
        Tooltip: Tooltip,
        tooltipProps: tooltipProps,
        onResize: onResizeHandler,
        onLayerClick: onLayerClick,
        // view: !_isEmpty(stateView) ? stateView : view,
        view: usedView,
        onViewChange: onViewChangeHandler,
        onZoomEnd: onZoomEnd,
        onPanEnd: onPanEnd,
        active: active,
        onClick: onClick,
        onMapRemove: onMapRemove,
        name: name,
        crs: crs
      }, wrapperProps), renderContent(mapComponent, _objectSpread(_objectSpread({
        // FIXME better props definition
        activeSelectionKey: activeSelectionKey,
        backgroundLayer: backgroundLayer,
        children: children,
        layers: layers,
        mapComponent: mapComponent,
        onMount: onMount,
        onUnmount: onUnmount,
        onPropViewChange: onPropViewChangeHandler,
        onResize: onResizeHandler,
        onLayerClick: onLayerClick,
        onViewChange: onViewChangeHandler,
        onZoomEnd: onZoomEnd,
        onPanEnd: onPanEnd,
        onClick: onClick,
        active: active,
        onMapRemove: onMapRemove,
        resetHeading: stateMapKey ? resetHeading : resetHeadingHandler,
        resources: resources,
        stateMapKey: stateMapKey,
        mapKey: mapKey,
        // view: !_isEmpty(stateView) ? stateView : view,
        view: usedView,
        viewport: viewport,
        viewLimits: viewLimits,
        wrapper: wrapper,
        Tooltip: Tooltip,
        crs: crs
      }, wrapperProps), {}, {
        tooltipProps: tooltipProps,
        name: name
      }, mapComponentProps ? mapComponentProps : {}), children));
    } else {
      return renderContent(mapComponent, _objectSpread({
        // FIXME better props definition
        activeSelectionKey: activeSelectionKey,
        backgroundLayer: backgroundLayer,
        children: children,
        layers: layers,
        mapComponent: mapComponent,
        onMount: onMount,
        onUnmount: onUnmount,
        onPropViewChange: onPropViewChangeHandler,
        onResize: onResizeHandler,
        onLayerClick: onLayerClick,
        onViewChange: onViewChangeHandler,
        onZoomEnd: onZoomEnd,
        onPanEnd: onPanEnd,
        active: active,
        onMapRemove: onMapRemove,
        onClick: onClick,
        resetHeading: stateMapKey ? resetHeading : resetHeadingHandler,
        resources: resources,
        stateMapKey: stateMapKey,
        mapKey: mapKey,
        // view: !_isEmpty(stateView) ? stateView : view,
        view: usedView,
        viewport: viewport,
        viewLimits: viewLimits,
        wrapper: wrapper,
        Tooltip: Tooltip,
        wrapperProps: wrapperProps,
        tooltipProps: tooltipProps,
        name: name,
        crs: crs
      }, mapComponentProps ? mapComponentProps : {}), children);
    }
  }
};
PresentationMap.propTypes = {
  mapKey: PropTypes.string,
  active: PropTypes.bool,
  activeSelectionKey: PropTypes.string,
  name: PropTypes.string,
  backgroundLayer: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  layers: PropTypes.array,
  mapComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  onMount: PropTypes.func,
  onUnmount: PropTypes.func,
  onMapRemove: PropTypes.func,
  onLayerClick: PropTypes.func,
  onPropViewChange: PropTypes.func,
  onResize: PropTypes.func,
  onViewChange: PropTypes.func,
  onZoomEnd: PropTypes.func,
  onPanEnd: PropTypes.func,
  onClick: PropTypes.func,
  resetHeading: PropTypes.func,
  resources: PropTypes.object,
  stateMapKey: PropTypes.string,
  view: PropTypes.object,
  viewport: PropTypes.object,
  viewLimits: PropTypes.object,
  wrapper: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.bool]),
  wrapperProps: PropTypes.object,
  Tooltip: PropTypes.elementType,
  tooltipProps: PropTypes.object,
  crs: PropTypes.string,
  mapComponentProps: PropTypes.object
};
export default PresentationMap;